import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { colors, media } from '../styles/vars'
import wavesImg from '../static/images/backgrounds/waves.jpg'
import playIcon from '../static/images/icons/small_play.png'
import pauseIcon from '../static/images/icons/pause2.png'

const infiniteMotion = keyframes`
0%{
    background-position:0;
}
100%{
    background-position:2000px;
}
`
const Container = styled.div`
padding:20px;
border:2px solid #393939;
color:${colors.white};
text-align:center;
background-color:${colors.black};
max-width:85%;
margin:0 auto;

${
    media.desktop`
    position:absolute;
    right:0;
    top:130px;
    width:400px;
    height:640px;
    max-width:initial;
    `
    }
`
const DynamicContainer = styled(Container) `
${
    media.desktop`
    transition:transform .8s;
    will-change:transform;
    transform:translate3d(${props => props.translateX ? `${props.translateX}px` : 0}, 0, 0);
    `
    }
`

const TextContainer = styled.div`
margin: 15px 0;
overflow-wrap:break-word;
max-height:48vw;
overflow-y:auto;
box-shadow: inset 0 -10px 20px -10px rgba(255, 255, 255, .6);
${
    media.desktop`
    max-height:initial;
    overflow:initial;
    box-shadow:none;
    `
    }
`

const Title = styled.h3`
font-size:3rem;
margin-bottom:10px;
text-align:right;
direction:ltr;
`
const Paragraph = styled.p`
font-size:2.4rem;
text-align:justify;
${
    media.small`
    text-align:right;
    `
    }
`
const StyledAudioPlayer = styled.div`
max-width:70%;
margin:0 auto;
padding-bottom:40%;
background-size:contain;
background-position:center;
background-image:url(${wavesImg});
position:relative;
cursor:pointer;
`
const DynamicAudioPlayer = styled(StyledAudioPlayer) `
animation:${props => props.active ? `${infiniteMotion} 30s linear infinite` : 'none'};
background-position:${props => `${props.pos}px`};
`
const PlayerStateIcon = styled.img`
position:absolute;
left:0;
right:0;
top:0;
bottom:0;
margin:auto;
transition:visibility .2s, opacity .2s;
`
const DynamicPlayerIcon = styled(PlayerStateIcon) `
visibility:${props => props.active ? `visible` : 'hidden'};
opacity:${props => props.active ? `1` : '0'};
`
class TimelineDetails extends Component {
    componentWillReceiveProps() {
        this.paragraphNode.scrollTop = 0;
    }
    render() {
        return (
            <DynamicContainer translateX={this.props.translateX}>
                <DynamicAudioPlayer
                    onClick={this.props.onPlayerClick}
                    active={this.props.isAudioPlaying}
                    pos={this.props.audioPosition}
                >
                    <DynamicPlayerIcon src={playIcon} active={!this.props.isAudioPlaying} />
                    <DynamicPlayerIcon src={pauseIcon} active={this.props.isAudioPlaying} />
                </DynamicAudioPlayer>
                <TextContainer innerRef={node => this.paragraphNode = node}>
                    <Title>{this.props.title}</Title>
                    <Paragraph>{this.props.text}</Paragraph>
                </TextContainer>
            </DynamicContainer>
        )
    }
}

export default TimelineDetails;


// WEBPACK FOOTER //
// ./src/components/TimelineDetails.jsx